/**
 * @generated SignedSource<<195ae034188c4e51e65979ae41eab767>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DocsExportModalMutation$variables = {
  includeMeetingRecap?: boolean | null;
  noteId?: string | null;
  streamId: string;
  title: string;
};
export type DocsExportModalMutation$data = {
  readonly exportStreamOrNoteToGoogleDocs: {
    readonly asyncResultId: any | null;
  } | null;
};
export type DocsExportModalMutation = {
  response: DocsExportModalMutation$data;
  variables: DocsExportModalMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeMeetingRecap"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "noteId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "streamId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "title"
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "includeMeetingRecap",
        "variableName": "includeMeetingRecap"
      },
      {
        "kind": "Variable",
        "name": "noteId",
        "variableName": "noteId"
      },
      {
        "kind": "Variable",
        "name": "streamId",
        "variableName": "streamId"
      },
      {
        "kind": "Variable",
        "name": "title",
        "variableName": "title"
      }
    ],
    "concreteType": "ExportStreamOrNoteToGoogleDocs",
    "kind": "LinkedField",
    "name": "exportStreamOrNoteToGoogleDocs",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "asyncResultId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "DocsExportModalMutation",
    "selections": (v4/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "DocsExportModalMutation",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "a6d67f3c4d28405fe51fe8bbeb83fd23",
    "id": null,
    "metadata": {},
    "name": "DocsExportModalMutation",
    "operationKind": "mutation",
    "text": "mutation DocsExportModalMutation(\n  $streamId: ID!\n  $title: String!\n  $noteId: ID\n  $includeMeetingRecap: Boolean\n) {\n  exportStreamOrNoteToGoogleDocs(streamId: $streamId, title: $title, noteId: $noteId, includeMeetingRecap: $includeMeetingRecap) {\n    asyncResultId\n  }\n}\n"
  }
};
})();

(node as any).hash = "3ec3c09b453e0ac7a5621f5e0707025c";

export default node;
